import { urlFor } from '@/sanity/lib/image';

export const getIconUrl = (icon: any): string | null => {
  if (!icon) return null;
  if (typeof icon === 'string') return icon;
  if (typeof icon === 'object') {
    // Check if it's a Sanity image object
    if ('_type' in icon && icon._type === 'image' && 'asset' in icon && icon.asset?._ref) {
      return urlFor(icon).width(64).height(64).fit('crop').quality(90).url();
    }
    // Check if it has asset.url (legacy format)
    if ('asset' in icon && icon.asset?.url) {
      return icon.asset.url;
    }
    // Check if it has direct url property
    if ('url' in icon && icon.url) {
      return icon.url;
    }
  }
  return null;
};
